export default (path?: string) => {
  if (!path) return '';

  const result = path.match(/district\/([a-fA-F\d]+(?:-[a-fA-F\d]+){1,})/);

  return result ? result[1] : '';
};
